import { Injectable } from '@angular/core';
import { map, Observable, of, ReplaySubject, switchMap, tap } from 'rxjs';
import { StartResponsePayload } from '@cpak/adp-cpak-bff-service-models';
import { StartRepositoryService } from './start-repository.service';
import { CountryConfigMapType } from '@cpak/interfaces';

@Injectable({
  providedIn: 'root',
})
export class StartService {
  private startResponse: ReplaySubject<StartResponsePayload | null> = new ReplaySubject<StartResponsePayload | null>(1);
  private countriesConfigMap?: Observable<CountryConfigMapType>;

  constructor(private startRepositoryService: StartRepositoryService) {}

  public getStart(): Observable<StartResponsePayload | null> {
    return this.startRepositoryService.getStart();
  }

  public getStartResponse(): Observable<StartResponsePayload | null> {
    return this.startResponse.asObservable();
  }

  public setStartResponse(response: StartResponsePayload | null): void {
    this.startResponse.next(response);
  }

  public getCountriesConfig(): Observable<CountryConfigMapType> {
    if (this.countriesConfigMap) return this.countriesConfigMap;
    return this.getStartResponse().pipe(
      map(response => response?.data.config.countries || []),
      tap(countries => {
        const countriesMap: CountryConfigMapType = new Map();
        countries.forEach(country => countriesMap.set(country.id, country));
        this.countriesConfigMap = of(countriesMap);
      }),
      switchMap(() => this.countriesConfigMap as Observable<CountryConfigMapType>)
    );
  }
}
